var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Menu',[_c('transition',{attrs:{"name":"page-transition","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1),_c('div',[_c(_vm.activeModal,_vm._b({tag:"component"},'component',_vm.payload,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }